import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import {MuiThemeProvider, createTheme} from '@material-ui/core/styles';

const materialTheme = createTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#42494E',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: "white",
      },
    },
    MuiPickersDay: {
      day: {
        // color: lightBlue.A700,
      },
      daySelected: {
        backgroundColor: '#42494E',
      },
      dayDisabled: {
        // color: lightBlue['100'],
      },
      current: {
        // color: lightBlue['900'],
      },
    },
    MuiPickersModal: {
      dialogAction: {
        // color: lightBlue['400'],
      },
    },
  },
});

export default function MaterialUIPickers(props) {
  // The first commit of Material-UI
  const {specialEndDate, setSpecialEndDate} = props;

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <MuiThemeProvider theme={materialTheme}>
        {/* <Grid container justifyContent="space-around"> */}
        {/* <KeyboardDatePicker
          disableToolbar
          variant="inline"
          format="MM/dd/yyyy"
          margin="normal"
          id="date-picker-inline"
          label="Date picker inline"
          value={selectedDate}
          onChange={handleDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        /> */}
        <KeyboardDatePicker
          style={{width: '100%'}}
          margin="dense"
          id="date-picker-dialog"
          label="Special End Date"
          format="dd/MM/yyyy"
          value={specialEndDate ? specialEndDate : null}
          // value={selectedDate}
          onChange={(e) => setSpecialEndDate(e)}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
        {/* <KeyboardTimePicker
          margin="normal"
          id="time-picker"
          label="Time picker"
          value={selectedDate}
          onChange={handleDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change time',
          }}
        /> */}
        {/* </Grid> */}
      </MuiThemeProvider>
    </MuiPickersUtilsProvider>
  );
}
